const Form045EN = {
    stepName: {
        statement: "Important Notes",
        notification: "Changes of Rates and/or Government Rent",
        information: "Information",
        confirmation: "Confirmation",
    },
    errorMsg: {
        needOne: "You must submit either 1 of the 3 attachments",
        float: {
            rule: 'This field must be a "number" type, maximum 2 decimal places',
        },
        requiredOne:
            "You must fill in either 'Rates' or 'Government Rate', or can fill both",
        amount: {
            rule: "Please input a valid Amount",
            max: "Amount must be at most 6 digits",
            maxDecimal: "Amount must be at most 2 decimal places",
            min: "The sum of previous amount and new amount must be greater than 0",
        },
        tel: {
            max: "Telephone number must be at most 30 digits",
        },
        maxChar: "This field must be at most 1000 characters",
    },
    serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],
    noteTitle1: "<u>Purpose of Collection</u>",
    noteTitle3: "<u>Classes of Transferees</u>",
    noteTitle4: "<u>Access to Personal Data</u>",
    notes: [
        "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",
        "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to  <a href='mailto:jokc@edb.gov.hk'>jokc@edb.gov.hk</a>.",
    ],
    notes1: [
        "Activities relating to the processing, authentication and counter-checking of the Changes of Rates and/or Government Rent;",
        "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        "Activities relating to compilation of statistics, research and Government publications; and",
        "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant / Subsidized Schools Provident Fund Rules); and the Codes of Aid, the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A) )",
    ],
    notes3: [
        "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
        "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        "where you have given your prescribed consent to such disclosure; and",
        "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
    ],
    label: {
        note: "Personal Information Collection Statement",
        statement: "Statement",
        importantNotesTitle: "Important Notes",
        importantNotes: `Applicant without an "iAM Smart+" account is required to return the completed form to Joint Office for Kindergartens and Child Care Centres for processing (Address: Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong). Please ensure that sufficient postage is paid to avoid unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.`,
        headStatement:
            "The rates and/or government rent of my school premises have been revised with effect from",
        headStatement1: "as follows–",
        certify1:
            "I have read, understood and agreed to the above terms and conditions.",
        smart: "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        successfulSubmissionMsgToA:
            "You have successfully submitted the form. Please note that this form is not yet received by EDB. It is pending approval from the School Approver.",
        date: "Date",
        period: "Period",
        previousAmount: "Previous Amount",
        newAmount: "New Amount",
        certifiedCopies:
            "Certified true copies of the relevant Demand Notes/rent card are attached for reference. ",
        demandNotesAttachment: "Demand Notes",
        rentCardAttachment: "Rent card",
        othersAttachment: "Others (e.g. notification from management office)",
        certify:
            "I should be grateful if you would adjust the amount of subsidy for rates and/or government rent accordingly. I certify that there is no change in the area of school portion eligible for subsidy previously approved by EDB.",
        format: "dd/MM/yyyy",
        attachment: "Copies of the relevant Demand Notes/rent card",
        agreement:
            "I should be grateful if you would adjust the amount of subsidy for rates and/or government rent accordingly. I certify that there is no change in the area of school portion eligible for subsidy previously approved by EDB.",
        specify: "Please specify",
        specification: "Reason",
        supervisorName: "Name of Supervisor",
        schoolName: "Name of School",
        contactPerson: "Contact Person",
        telNo: "Telephone No.",
        certOptions: {
            demandNotesAttachment: "Demand Notes",
            rentCardAttachment: "Rent card",
            othersAttachment:
                "Others (e.g. notification from management office)",
        },
        infor: "Information",
    },
    amountValue: {
        Rates: "Rates:",
        "Government Rent": "Government Rent:",
    },
    periodRValue: {
        Quarter: "Per Quarter",
        Month: "Per Month",
        NA: "N/A",
    },
    periodGValue: {
        Quarter: "Per Quarter",
        Month: "Per Month",
        "Half year": "Per Half year",
        NA: "N/A",
    },
};
export default Form045EN;
